import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';

import { SuiContainer, SuiDropdown, SuiDropdownOption, SuiButton } from '@splashthat/sui';
import TrashIcon from 'common/icons/Trash';
import NodeOptionsManager from './NodeOptionsManager';
import { getOperatorOptions, isOperandCheckbox } from '../../utils/formLogicHelperFunctions';

const FormLogicOperations = ({
    operandNodes,
    operandNode,
    operandLeft,
    operator,
    operandRight,
    allowMultipleInput,
    // Behaviour methods
    handleChangeOperandLeft,
    handleChangeOperator,
    handleChangeOperandRight,
    handleClickRemoveCondition,
    addValueToSet,
    formNodeWithLogicIsProtected,
}) => (
    <SuiContainer variation="flex-horizontal flex-inherit flex-groups-grow" grow={1}>
        {/* Operand left. node selection */}
        <SuiContainer variation="flex-group">
            <SuiDropdown
                className="qa-logic-question-dd" /* id for selenium tests */
                fullWidth
                placeholder="Select a question"
                value={operandLeft}
                onChange={handleChangeOperandLeft}
            >
                {operandNodes.map((node) => (
                    <SuiDropdownOption
                        key={node.id}
                        displayValue={node.label}
                        value={node.id}
                        disabled={formNodeWithLogicIsProtected ? !node.protected : node.protected}
                    />
                ))}
            </SuiDropdown>
        </SuiContainer>

        {/* Operator. eg: equals, greater than, ... */}
        <SuiContainer variation="flex-group">
            <SuiDropdown
                className="qa-logic-operator-dd" /* id for selenium tests */
                fullWidth
                value={operator}
                onChange={handleChangeOperator}
            >
                {getOperatorOptions(operandNode).map(({ displayValue, value }) => (
                    <SuiDropdownOption key={value} displayValue={displayValue} value={value} />
                ))}
            </SuiDropdown>
        </SuiContainer>

        {/* Operand right. value selection */}
        <SuiContainer variation="flex-group">
            <NodeOptionsManager
                operandNode={operandNode}
                operandValue={operandRight}
                onChange={handleChangeOperandRight}
                onValueDefined={addValueToSet}
                useAdvancedTagsInput={allowMultipleInput}
                displayCheckboxOptions={isOperandCheckbox(operandNode)}
            />
        </SuiContainer>
        <SuiContainer variation="flex-group flex-shrinkwrap">
            <SuiButton variation="navigation" size="small" onClick={handleClickRemoveCondition} icon={TrashIcon} />
        </SuiContainer>
    </SuiContainer>
);

FormLogicOperations.propTypes = {
    operandNodes: PropTypes.array.isRequired,
    operandNode: PropTypes.object,
    operandLeft: PropTypes.any.isRequired,
    operator: PropTypes.string.isRequired,
    handleChangeOperandLeft: PropTypes.func.isRequired,
    handleChangeOperator: PropTypes.func.isRequired,
    handleClickRemoveCondition: PropTypes.func.isRequired,
    formNodeWithLogicIsProtected: PropTypes.bool.isRequired,
    operandRight: PropTypes.any,
    handleChangeOperandRight: PropTypes.func,
    allowMultipleInput: PropTypes.bool,
    addValueToSet: PropTypes.func,
};

FormLogicOperations.defaultProps = {
    operandNode: null,
    operandRight: null,
    handleChangeOperandRight: noop,
    allowMultipleInput: false,
    addValueToSet: noop,
};

export default FormLogicOperations;
